import React, { ReactElement } from 'react';
import { Typography } from '../../Typography/Typography';
import styles from '../Table.module.scss';
import classNames from 'classnames/bind';
import { TTableVariant } from '../types';

export interface ITableCellProps {
  row: Record<string, string | JSX.Element>;
  header: string;
  colWidth?: number;
  placeholderImage?: string;
  rowHeight?: TTableVariant;
}

const cx = classNames.bind(styles);

const TableCell = ({ row, header, placeholderImage, colWidth, rowHeight }: ITableCellProps): ReactElement => {
  const imageSrc = typeof row['image'] === 'string' && row['image'] ? row['image'] : placeholderImage;
  const rowName = typeof row['name'] === 'string' && row['name'] ? row['name'] : 'row-image';

  return (
    <td className={cx('cell', { 'cell-compact': rowHeight === 'compact' })} style={{ width: `${colWidth}%` }}>
      {typeof row[header] === 'string' ? (
        <>
          {header === 'image' ? (
            <div className={styles['image']}>
              {(row[header] || placeholderImage) && <img src={imageSrc} alt={rowName} loading="lazy" />}
            </div>
          ) : (
            <Typography size="M" transform="uppercase-first-letter">
              {row[header]}
            </Typography>
          )}
        </>
      ) : (
        <div onClick={(e) => header === 'actions' && e.stopPropagation()}>{row[header]}</div>
      )}
    </td>
  );
};

export default TableCell;
